var React = require('react');

var GenericSimpleButton = function (props) {
    return (
        <button id={props.buttonId} type={props.buttonType} className={props.buttonClass} title={props.title} data-dismiss={props.dataDismiss} onClick={props.onClick}>{props.text}</button>
    );
}

export default GenericSimpleButton